// extracted by mini-css-extract-plugin
export default {"table":"myPackTableList_table__GlKlA"};